export enum AuthEvent {
  SigninSuccess = 'login_success',
  SignupSuccess = 'signup_success',
  SignoutSuccess = 'logout_success',
}
